import styled from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Container from "../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import {
    lineClampStyle,
    type LineClampStyleType,
} from "../../../../../../common-deprecated/styles/v2/toyota/utilities/LineClamp";

export const Wrapper = styled(Container.default)`
    margin-bottom: 80px;
`;

export const Title = styled(Type.H2)<LineClampStyleType>`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 2.2rem;
    line-height: 1.2;
    ${lineClampStyle};
`;

export const CustomizeButton = styled.a`
    font-size: 1.3rem;
    color: ${theme.colors.grey7};
    span {
        position: relative;
        top: 1px;
        margin-right: ${theme.space[1] / 2}px;
    }

    .professional-theme & {
        color: ${theme.colors.primaryWhite};
    }

    html[dir="rtl"] & {
        span {
            margin-left: ${theme.space[1] / 2}px;
            margin-right: 0;
        }
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Description = styled.p.attrs(() => ({
    className: "body-text",
}))`
    margin-bottom: ${theme.space[3]}px;
    color: ${theme.colors.grey7};

    .professional-theme & {
        color: ${theme.colors.primaryWhite};
    }
`;
